import quantizeTime from './lib/quantizeTime';

export default class Note {
  constructor(noteIndex, instrument, options = {}) {
    if (typeof noteIndex === 'undefined' || !Number.isFinite(noteIndex)) throw new Error('no Note index passed');

    Object.assign(this, {
      noteIndex: noteIndex,
      instrument: instrument,
      time: '+0',
      active: true, // Will it play or just skip?
      duration: '4n',
      allowMutations: true,
      velocity: .8,
      mutations: []
    }, options);
  }

  play(verbose) {
    if (!this.active) return;
    if (!this.instrument) throw new Error('note has no instrument');
    const note = this.getNoteValue();

    this.instrument.synth.triggerAttackRelease(
      note, this.duration, this.time, this.velocity
    );

    this.instrument.history.push(this);
    if (verbose) console.log(this.noteIndex, note, this);
  }

  getNoteValue() {
    if (!this.instrument) throw new Error('note has no instrument');
    return this.instrument.notes[this.noteIndex];
  }

  delay(amount) {
    if (!amount || !amount.length) return;
    this.time = quantizeTime(this.time += '+' + amount);
    return this;
  }

  transpose(amount) {
    this.noteIndex += amount;
    return this;
  }

  clone(options) {
    return new Note(this.noteIndex, this.instrument, options);
  }

  adjustLength(ratio) {
    this.duration += '*' + ratio;
    return this;
  }

  logMutation(mutationName) {
    // console.log('[MUTATION]', mutationName);
    this.mutations.push(mutationName);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/Note.js